"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sentry = exports.logger = void 0;

var gateway_1 = require("./gateway");

var Sentry = __importStar(require("@sentry/react"));

var methods = Object.keys(console);
var gateway = new gateway_1.Gateway();
var LOGGER_TAG = 'Unknown app';
var LOGGER_UUID = 'Unauthorized';
var LEVELS = {
  trace: 6,
  log: 5,
  debug: 5,
  info: 4,
  warn: 3,
  error: 2
};

function stringify(obj) {
  var cache = [];
  return JSON.stringify(obj, function (key, value) {
    if (typeof value === 'object' && value !== null) {
      if (cache.indexOf(value) !== -1) {
        try {
          return JSON.parse(JSON.stringify(value));
        } catch (error) {
          return;
        }
      }

      cache.push(value);
    }

    return value;
  });
}

exports.logger = {
  init: function init(options) {
    Sentry.init(options);
    Sentry.setUser({
      uuid: LOGGER_UUID
    });
  },
  setConfig: function setConfig(config) {
    if (config.uuid) LOGGER_UUID = config.uuid;
    if (config.tag) LOGGER_TAG = config.tag;
    gateway.setConfig({
      url: config.url,
      timeout: config.timeout
    });
  },
  debug: function debug() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return '';
  },
  info: function info() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return '';
  },
  warn: function warn() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return '';
  },
  error: function error() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return '';
  }
};
exports.sentry = Sentry;
methods.forEach(function (method) {
  var old = console[method];

  if (typeof console[method] !== 'function') {
    return;
  }

  exports.logger[method] = function (text) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    old.apply(this, arguments);
    gateway.pushLog({
      clientTime: new Date(),
      tag: LOGGER_TAG,
      message: method + ": " + text + " " + (args.length ? stringify(args) : '') + " ",
      level: LEVELS[method] || LEVELS.trace,
      uuid: LOGGER_UUID
    });
  };
});